import React from 'react'
import Viewer from 'viewerjs'

import 'viewerjs/dist/viewer.css'

import styles from './style.module.scss'

interface ImageItem {
  src: string
  alt?: string
}

interface ImageViewerProps {
  images: ImageItem[]
  onClose?: () => void
  onDownload?: () => void
  viewerOptions?: any
}

class ImageViewer extends React.Component<ImageViewerProps> {
  viewer: Viewer | null = null

  prevRef: HTMLUListElement | null = null

  componentDidMount(): void {}

  componentWillUnmount(): void {
    if (this.viewer != null) {
      this.viewer.destroy()
    }
  }

  onSetRef = (ref: HTMLUListElement | null): void => {
    const { onClose, onDownload, viewerOptions } = this.props

    if (ref !== this.prevRef) {
      if (this.prevRef != null && this.viewer != null) {
        this.viewer.destroy()
      }

      if (ref != null) {
        const options = viewerOptions || {}
        this.viewer = new Viewer(ref, {
          inline: false,
          initialCoverage: 0.9,
          className: styles.imageViewer,
          toolbar: {
            zoomIn: true,
            zoomOut: true,
            oneToOne: true,
            reset: true,
            prev: false,
            play: false,
            next: false,
            rotateLeft: true,
            rotateRight: true,
            flipHorizontal: true,
            flipVertical: true,
            download: () => {
              console.log(' download - ')
              if (onDownload != null) {
                onDownload()
              }
            },
          },
          ...options,
        })

        ref.addEventListener('hidden', () => {
          if (onClose != null) {
            onClose()
          }
        })

        this.viewer.show()
      }

      this.prevRef = ref
    } else if (this.viewer != null) {
      this.viewer.update()
    }
  }

  render(): React.ReactNode {
    const { images } = this.props

    const children = images.map((item) => {
      return (
        <li key={item.src}>
          <img src={item.src} alt={item.alt} />
        </li>
      )
    })

    return (
      <ul className={styles.imageViewer} ref={this.onSetRef}>
        {children}
      </ul>
    )
  }
}

export default ImageViewer
